// extracted by mini-css-extract-plugin
export default {"UserAdministratorPage":"UserAdministrator_UserAdministratorPage__pf7iC","UserAdministratorPage__content":"UserAdministrator_UserAdministratorPage__content__yV6iS"};